module.exports = __webpack_public_path__ + "img/album15_21.cc5660d2.jpg";